import { useEffect, useState } from 'react';

type UseDelayedEligibilityArgs = {
	isEligible: boolean;
	delayMs: number;
};

/**
 * Delays an eligibility signal before returning true.
 * Intended for onboarding surfaces that should not render immediately after mount.
 */
export const useDelayedEligibility = ({
	isEligible,
	delayMs,
}: UseDelayedEligibilityArgs): boolean => {
	const [isDelayElapsed, setIsDelayElapsed] = useState(false);

	useEffect(() => {
		if (!isEligible || isDelayElapsed) {
			return;
		}

		const timeoutId = globalThis.setTimeout(() => {
			setIsDelayElapsed(true);
		}, delayMs);

		return () => {
			globalThis.clearTimeout(timeoutId);
		};
	}, [delayMs, isDelayElapsed, isEligible]);

	return isEligible && isDelayElapsed;
};
